import { akedlyInboxQueryKeys as e } from "./akedlyInboxQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminPhoneAuthApi as n } from "@maat/api-main";
//#region src/phoneAuth/admin/useAkedlyInboxDeliveryQuery.ts
var r = (r) => t({
	queryKey: e.delivery(r ?? ""),
	queryFn: () => n.getInboxDelivery(r),
	enabled: !!r
});
//#endregion
export { r as useAkedlyInboxDeliveryQuery };
